export interface LocalListStore {
  subscribe: (listener: () => void) => () => void;
  getSnapshot: () => string[];
  set: (next: string[]) => void;
  add: (id: string) => void;
  addFront: (id: string, max?: number) => void;
  remove: (id: string) => void;
  toggle: (id: string) => void;
  has: (id: string) => boolean;
}

function readList(key: string): string[] {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((item): item is string => typeof item === 'string')
      : [];
  } catch {
    return [];
  }
}

export function createLocalListStore(key: string, cap = 200): LocalListStore {
  let cached: string[] = readList(key);
  const listeners = new Set<() => void>();

  function emit() {
    listeners.forEach((listener) => listener());
  }

  function set(next: string[]) {
    cached = next;
    try {
      localStorage.setItem(key, JSON.stringify(next));
    } catch {
      // storage unavailable, keep in-memory state
    }
    emit();
  }

  return {
    subscribe(listener: () => void) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    getSnapshot() {
      return cached;
    },
    set,
    add(id: string) {
      if (!cached.includes(id)) set([...cached, id]);
    },
    addFront(id: string, max = cap) {
      set([id, ...cached.filter((item) => item !== id)].slice(0, max));
    },
    remove(id: string) {
      set(cached.filter((item) => item !== id));
    },
    toggle(id: string) {
      if (cached.includes(id)) {
        set(cached.filter((item) => item !== id));
      } else {
        set([...cached, id]);
      }
    },
    has(id: string) {
      return cached.includes(id);
    },
  };
}